import { useEffect, useState } from 'react';
const useCounter = (targetDate?: Date) => {
    const counterDate = targetDate ? new Date(targetDate).getTime() : new Date().getTime();
    const [counter, setCounter] = useState<number>(new Date().getTime() - counterDate);

    useEffect(() => {
        setCounter(new Date().getTime() - counterDate);

        const interval = setInterval(() => {
            setCounter(new Date().getTime() - counterDate);
        }, 1000);

        return () => clearInterval(interval);
    }, [counterDate]);

    return getReturnValues(counter);
};

const getReturnValues = (countDown: number) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    return [days, hours, minutes, seconds];
};

export default useCounter;
